import { render, staticRenderFns } from "./SelectPerPage.vue?vue&type=template&id=95bfbce2&scoped=true"
import script from "./SelectPerPage.vue?vue&type=script&lang=ts"
export * from "./SelectPerPage.vue?vue&type=script&lang=ts"
import style0 from "./SelectPerPage.vue?vue&type=style&index=0&id=95bfbce2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bfbce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95bfbce2')) {
      api.createRecord('95bfbce2', component.options)
    } else {
      api.reload('95bfbce2', component.options)
    }
    module.hot.accept("./SelectPerPage.vue?vue&type=template&id=95bfbce2&scoped=true", function () {
      api.rerender('95bfbce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/SelectPerPage/SelectPerPage.vue"
export default component.exports